module.exports = __webpack_public_path__ + "media/error.08d42a52.mp3";